import '@fontsource-variable/inter/wght.css';
import '@fontsource-variable/inter/wght-italic.css';
import './scss/style.scss';
import { initContactMaps } from './ts/contact-map';
import { initFaqSections } from './ts/faq';
import { initGalleries } from './ts/gallery';
import { initVideoTeasers } from './ts/video-teaser';
import { initProductFilters, initProductGridLoadMore, initProductLightboxes, initProductSliders } from './ts/products';
import { initHeaderNavigation } from './ts/header-navigation';
import { initOnepageNavigation } from './ts/onepage-navigation';
import { initBenefitsAnimations } from './ts/benefits';

document.documentElement.classList.add('has-js');

initGalleries();
initVideoTeasers();
initFaqSections();
initContactMaps();
initProductSliders();
initProductFilters();
initProductGridLoadMore();
initProductLightboxes();
initHeaderNavigation();
initOnepageNavigation();
initBenefitsAnimations();
